import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "@/assets/Font/iconfont.css" // 阿里云iconFont图标

// 轮播图
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)


Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


// 注册全局组件
// import name from './components/name.vue'
// Vue.component('name',name);
